module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/1c0ed4dde64da7ee714183a39c18ae4a.png";